<template>
    <v-row class="ma-0 faqs-display-container">
        <v-card tile>
            <v-expansion-panels 
            variant="accordion"
            class="pt-13 pb-8 px-3 tj-elevation-1"
            :style="{background: this.$vuetify.theme.dark ? '#363636' : '#ffffff'}"
            >
                <v-expansion-panel v-for="(item,i) in faqs" :key="i" class="mb-5">
                    
                    <v-expansion-panel-title class="font-weight-bold">{{item.question}}</v-expansion-panel-title>
                    
                    <v-expansion-panel-text v-html="item.answer"></v-expansion-panel-text>

                </v-expansion-panel>
            </v-expansion-panels>
        </v-card>
    </v-row>
</template>

<script>
import db from '@/firebase/init'

export default {
    name: 'Faqs',
    data() {
        return {
            faqs: []
        }
    },
    methods: {
        getFaqs() {
            this.faqs = []
            let faqsRef = db.collection('faqs')
            faqsRef = faqsRef.orderBy('order')
            faqsRef.get().then(snapshot => {
                snapshot.forEach(doc => {
                    let faq = doc.data()
                    faq.id = doc.id
                    this.faqs.push(faq)
                })
                
                this.faqs.sort((a, b) => (a.order > b.order) ? 1 : -1)
                
            })
        }
    },
    created() {
        this.getFaqs()
    }
}
</script>

<style>
.faqs-display-container .v-expansion-panel-content {
    flex-direction: column;
    padding: 25px;
}
.faqs-display-container .v-expansion-panel-content img {
    object-fit: contain;
    max-width: 100%;
}
</style>